import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Pagination, UserContentTaskList } from '@core/entities';
import { FilterQuery } from '@core/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TaskService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  /**
   * Get all approved tasks
   * @description Get all approved tasks and if userId is provided, get all approved tasks for the user
   * @param userId
   */
  find() {
    return this._http.get<any>(`${this._apiUrl}/getAllApprovedTasks`).pipe(
      map((response: any) => {
        return response.result;
      }),
    );
  }

  get(taskId: number) {
    return this._http.get<any>(`${this._apiUrl}/get-task-by-id/${taskId}`).pipe(
      map((response: any) => {
        return response.result[0];
      }),
    );
  }

  create(formData: FormData) {
    return this._http.post<any>(`${this._apiUrl}/createTask`, formData);
  }

  update(formData: FormData, taskId: number) {
    return this._http.put<any>(`${this._apiUrl}/updateTask/${taskId}`, formData);
  }

  delete(taskId: number) {
    return this._http.delete<any>(`${this._apiUrl}/DeleteTask/${taskId}`);
  }

  markAsRead() {
    return this._http.get(`${this._apiUrl}/mark-as-read/tasks`);
  }

  getCollaborators(taskId: number) {
    return this._http.get<any>(`${this._apiUrl}/getTaskCollaborator/task/${taskId}`);
  }

  getContentTasks(pagination: Partial<Pagination>, queryParams?: FilterQuery): Observable<UserContentTaskList> {
    return this._http.get<any>(`${this._apiUrl}/getOwnerTasks/${pagination.page}/${pagination.pageSize}`, { params: queryParams });
  }

  approveTaskById(taskId: number) {
    return this._http.get<any>(`${this._apiUrl}/approveTaskById/task/${taskId}`);
  }

  approveSubtaskById(subtaskId: number) {
    return this._http.get<any>(`${this._apiUrl}/complete-subtask-by-id/${subtaskId}`);
  }

  getTasksByUserId(userId: number) {
    return this._http.get<any>(`${this._apiUrl}/getAllApprovedTasks/user/${userId}`).pipe(
      map((response: any) => {
        return response.result;
      }),
    );
  }
}
